export enum RolePermissions {
  LEADER = 1,
  ADMIM,
  MEMBER,
  TOURIST
}
